import React, {Component} from 'react';
import UserAttributesTable from "./UserAttributesTable";
import {PropTypes} from 'prop-types';

class UserAttributes extends Component {
  static propTypes = {
    userAttributes: PropTypes.any,
    capabilitiesMappingId: PropTypes.string,
    handleAddUserAttribute: PropTypes.func,
    handleDelUserAttribute: PropTypes.func,
    handleUpdateUserAttributes: PropTypes.func,
  }

  static defaultProps = {
    capabilitiesMappingId: "UserAttributes"
  };
  handleAddEvent = () => {
    this.props.handleAddUserAttribute();
  }
  handleDelEvent = (target) => {
    this.props.handleDelUserAttribute(target);
  }
  handleUserAttributesTable = (evt) => {
    this.props.handleUpdateUserAttributes(evt);
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {idpUserAttributes} = this.props;
    return (
        <div className="pt-31">
          <UserAttributesTable
              onUserAttributesTableUpdate={this.handleUserAttributesTable}
              displayUserExtendedAttributes={this.props.displayUserExtendedAttributes}
              displayFlexibleAttributes={this.props.displayFlexibleAttributes}
              extendedAttributes={this.props.extendedAttributes}
              onRowAdd={this.handleAddEvent}
              onRowDel={this.handleDelEvent}
              userAttributes={idpUserAttributes}/>
        </div>
    );
  }
}

export default UserAttributes;




